import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

function BookingMap({ icon, text, active, current, linkroute }) {
  return (
    <div>
      <div className="block xl:w-[5rem] 2xl:w-auto">
        <div className="relative">
          <span className="flex h-6 w-6 xl:w-6 2xl:w-6 mx-auto">
            {current && (
              <span className="pt-5 absolute inline-flex h-4 w-6 xl:w-6 2xl:w-6 rounded-full border-b-2 border-secondary opacity-100"></span>
            )}
            <FontAwesomeIcon
              icon={icon}
              className={`w-4 h-4 block  mx-auto ${
                active && "text-secondary"
              }  `}
            />
          </span>

          <div className="text-[10px] text-center">{text}</div>
        </div>
      </div>
    </div>
  );
}

export default BookingMap;
